import styled from "styled-components";

export const NotFoundImageContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0.5rem;
  margin-top: 15rem;
`;

export const NotFoundImage = styled.img`
  max-width: 100%;
`;
